import React, { useState } from 'react';
import { useEffect } from 'react';
import { useCallback } from 'react';

import { geolocate } from '../../../utils/geolocate';
import Form from '../../UI/Form/Form';

const PostcodeSearch = ({ onGeolocate, value, ...other }) => {
  const [ currentValue, setValue ] = useState('');
  const [ isGeolocating, setGeolocating ] = useState(false);
  const [ errorMessage, setErrorMessage ] = useState(null);

  const findLocation = useCallback(
    async (location) => {
      if (!location) {
        if (onGeolocate) onGeolocate(null, location);
        return;
      }

      setGeolocating(true);

      const results = await geolocate(location);

      if (!results?.features.length) {
        setErrorMessage(`The location entered was not found.`);
        setGeolocating(false);
        return;
      }

      const match = results?.features[ 0 ];
      const postcode = match.context.find((item) =>
        item.id.includes('postcode')
      );

      setGeolocating(false);
      setValue(postcode?.text || match.text);

      if (onGeolocate) {
        onGeolocate(match, location);
      }
    },
    [ onGeolocate ]
  );

  function handleLocateBtnCLick() {
    setGeolocating(true);

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        findLocation(`${coords.longitude},${coords.latitude}`);
      },
      () => {
        setGeolocating(false);
      }
    );
  }

  function handleKeyUp(e) {
    if (e.keyCode === 13) {
      findLocation(e.target.value);
      setErrorMessage(null);
    }
  }

  useEffect(() => {
    if (value) {
      findLocation(value);
    }
  }, [ value, findLocation ]);

  return (
    <Form.Input
      label="Enter your postcode..."
      placeholder="e.g. RH11 9BJ"
      name="postcode"
      id="postcode"
      btnIcon="crosshair"
      btnLabel="Locate"
      value={isGeolocating ? `Geolocating...` : currentValue}
      readOnly={isGeolocating}
      onBtnClick={handleLocateBtnCLick}
      onKeyUp={handleKeyUp}
      errorMessage={errorMessage}
      pattern="^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$"
      {...other}
    />
  );
};

export default PostcodeSearch;
